import { render, staticRenderFns } from "./ManagementNotes.vue?vue&type=template&id=1c1ba82a&"
import script from "./ManagementNotes.vue?vue&type=script&lang=js&"
export * from "./ManagementNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports